import accordion from '@components/accordion';

export default (block) => {
  const items = block.querySelector('.faq-block-items');

  if (items) {
    accordion(items);
  }
};
